var Reverb = window.Reverb || {};
Reverb.Listing = Reverb.Listing || {};

Reverb.Listing.Soundcloud = (function () {
  var soundcloudLinkSelector = '[data-soundcloud-link]';
  var soundcloudSpinnerSelector = '[data-soundcloud-verification-spinner]';
  var soundcloudLinkErrorSelector = '[data-soundcloud-verification-link-error]';
  var soundcloudStreamableErrorSelector = '[data-soundcloud-verification-streamable-error]';

  function soundcloudClientId() {
    return '4d16538edd7d9ed1034801675178d437';
  }

  function soundcloudResolveUrl(soundcloudLink) {
    return '//api.soundcloud.com/resolve.json?url=' + soundcloudLink + '&client_id=' + soundcloudClientId();
  }

  function linkErrorMessage() {
    return $(soundcloudLinkErrorSelector);
  }

  function streamableErrorMessage() {
    return $(soundcloudStreamableErrorSelector);
  }

  function verifySoundcloudLinkIfPresent() {
    var soundcloudLink = $(soundcloudLinkSelector).val();

    Reverb.Forms.removeErrorUi(soundcloudLinkSelector);
    linkErrorMessage().hide();
    streamableErrorMessage().hide();

    if (soundcloudLink.length) {
      if (linkDoesNotContainSoundcloud(soundcloudLink)) {
        soundcloudVerificationFailed(linkErrorMessage());
        return;
      } else {
        verifySoundcloudLink(formattedSoundcloudLink(soundcloudLink));
      }
    }
  }

  function verifySoundcloudLink(soundcloudLink) {
    var soundcloudVerificationSpinner = $(soundcloudSpinnerSelector);

    soundcloudVerificationSpinner.show();

    $.get(soundcloudResolveUrl(soundcloudLink))
      .fail(function () {
        soundcloudVerificationFailed(linkErrorMessage());
      })
      .done(function (e) {
        if (e.streamable == false) {
          soundcloudVerificationFailed(streamableErrorMessage());
        }
      })
      .always(function () {
        soundcloudVerificationSpinner.hide();
      });
  }

  function formattedSoundcloudLink(soundcloudLink) {
    var formattedSoundcloudLink = 'https://' + soundcloudLink.substring(soundcloudLink.indexOf('soundcloud.com'));

    $(soundcloudLinkSelector).val(formattedSoundcloudLink);

    return formattedSoundcloudLink;
  }

  function linkDoesNotContainSoundcloud(link) {
    return link.indexOf('soundcloud.com') === -1;
  }

  function soundcloudVerificationFailed(errorMessage) {
    errorMessage.show();
    Reverb.Forms.addErrorUi(soundcloudLinkSelector);
  }

  function bindSoundcloudLinkBlur() {
    $(soundcloudLinkSelector).blur(verifySoundcloudLinkIfPresent);
  }

  function init() {
    bindSoundcloudLinkBlur();
  }

  return {
    init: init
  };
})();

$(function () { Reverb.Listing.Soundcloud.init(); });



// WEBPACK FOOTER //
// ./javascripts/components/legacy/listing/soundcloud.js